import { render, staticRenderFns } from "./simpleButton.vue?vue&type=template&id=0104b48c&scoped=true&"
import script from "./simpleButton.vue?vue&type=script&lang=js&"
export * from "./simpleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0104b48c",
  null
  
)

export default component.exports